import { connect } from 'react-redux'

import DriverKeyModal from '../../../pages/settings/components/Modals/DriverKeyModal'

import {
  assignToDriver,
  fetchKeys,
  getKeysMore,
  onSearchKeys,
  pageChangedKeys,
  resetConfig,
} from '../../../redux/configuration/actions'

import {
  getConfigSuccess,
  getErrorMessageConfig,
  getIsLoadingAssign,
  getKeys,
  getKeysCount,
  getKeysListIsLoading,
} from '../../../redux/configuration/selectors'
import {
  getDriversSettings,
  getDriversSettingsCount,
  getDriversSettingsListIsLoading,
} from '../../../redux/driver/selectors'
import {
  fetchDrivers,
  getDriversMore,
  onAjoutSearchDriver,
  pageChangedDrivers,
  resetDriversConfig,
} from '../../../redux/driver/actions'

const mapStateToProps = (state) => ({
  drivers: getDriversSettings(state),
  isLoadingDrivers: getDriversSettingsListIsLoading(state),
  driversCount: getDriversSettingsCount(state),
  keys: getKeys(state),
  isLoadingAssign: getIsLoadingAssign(state),
  success: getConfigSuccess(state),
  errorMessage: getErrorMessageConfig(state),
  isLoadingKeysList: getKeysListIsLoading(state),
  keysCount: getKeysCount(state),
})

const mapDisptachToProps = (dispatch) => ({
  fetchDrivers: () => {
    dispatch(onAjoutSearchDriver(''))
    dispatch(fetchDrivers())
  },

  searchDrivers: (search) => {
    dispatch(onAjoutSearchDriver(search))
    dispatch(pageChangedDrivers(0))
    dispatch(fetchDrivers())
  },

  fetchMoreDrivers: (offset, search) => {
    dispatch(pageChangedDrivers(offset))
    dispatch(onAjoutSearchDriver(search))
    dispatch(getDriversMore())
  },

  resetDriver: () => dispatch(resetDriversConfig()),

  fetchKeys: () => dispatch(fetchKeys()),
  searchKeys: (search) => {
    dispatch(onSearchKeys(search))
    dispatch(pageChangedKeys(0))
    dispatch(fetchKeys())
  },
  fetchMoreKeys: (offset) => {
    dispatch(pageChangedKeys(offset))
    dispatch(getKeysMore())
  },
  resetConfig: () => dispatch(resetConfig()),
  assign: (data) => dispatch(assignToDriver(data)),
})

export default connect(mapStateToProps, mapDisptachToProps)(DriverKeyModal)
